/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useMemo } from "react";
// Material Dashboard 2 React components
import {
  IconButton,
  InputAdornment,
  TextField,
  Button,
  Alert,
  Box,
  Grid,
  RadioGroup,
  FormGroup,
  Radio,
  FormControlLabel,
  Dialog,
  FormHelperText,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Autocomplete,
  Switch,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useMaterialUIController } from "context";
// import themeLight from "assets/theme";
// import themeDark from "assets/theme-dark";
import MDBox from "components/MDBox";
// import CssBaseline from "@mui/material/CssBaseline";
import { createTheme } from "@mui/material/styles";
import colors from "assets/theme/base/colors";
import { MenuProps } from "utils/constants";
import { API_ROUTES } from "utils/constants";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { APP_URL, validateArrayFileRequired } from "utils/constants";
import { useRecoilValue } from "recoil";
import { SettingState } from "states";

const defaultValue = {
  maphuong: null,
  maquan: null,
  gioitinh: "M",
  first_name: "",
  last_name: "",
  username: "",
  password: "",
  repassword: "",
  birth_date: null,
  is_active: false,
  gender: "M",
  address: "",
  donvi: "",
  auth2: false,
};

const CRUDUser = ({
  open,
  data,
  onClose,
  onSubmit,
  title,
  visible,
  validationErrors,
  dataGroup,
  dataHuyen,
}) => {
  const [controller, dispatch] = useMaterialUIController();
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const { darkMode } = controller;
  const themeLight = createTheme({
    palette: {
      primary: {
        main: colors.info.main,
      },
      background: {
        default: colors.background.default,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });
  const themeDark = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: colors.info.main,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });
  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    username: "",
    birth_date: "",
    password: "",
    repassword: "",
    email: "",
    picture: [],
  });
  const [dataState, setDataState] = useState(defaultValue);
  const axiosPrivateInstance = useAxiosPrivate();
  const [optionSubDitrict, setOptionSubDitrict] = useState([]);
  // const [checkAuth2, setcheckAuth2] = useState(false);
  const formRef = useRef(null);
  const [values, setValues] = useState({
    showPass: false,
  });
  const [revalues, setReValues] = useState({
    showPass: false,
  });
  const settingState = useRecoilValue(SettingState);

  const [group, setGroup] = useState([]);
  const dicGroup = useMemo(() => {
    let dic = {};
    dataGroup?.map((item, index) => {
      dic[item?.id] = {
        id: item?.id,
        name: item?.name,
      };
    });
    return dic;
  }, [dataGroup]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const form = formRef.current;
    const formData = new FormData(form);
    const _data = {};
    formData.forEach((value, key) => {
      if (!_data[key]) {
        _data[key] = key === "picture" ? [value] : value;
      } else {
        _data[key].push(value);
      }
    });
    _data["id"] = data?.id;
    _data["rowIndex"] = data?.rowIndex;
    _data["group"] = group?.map((item) => item?.id);
    _data["domain"] = APP_URL;
    _data["auth2"] = dataState["auth2"];
    const newValidationErrors = validateOBJ(
      _data,
      visible,
      settingState["dungluong_file_upload"]
    );
    let _tempValid = newValidationErrors;
    if (Object.values(_tempValid["picture"]).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    delete _tempValid["picture"];

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    if (validateEmail(_data["email"])) {
      setErrors({
        ...errors,
        email: "Địa chỉ Email không đúng định dạng",
      });
      return;
    }
    if (visible) {
      if (checkconfirmpassword(_data["password"], _data["repassword"])) {
        setErrors({
          ...errors,
          repassword: "Mật khẩu không khớp",
        });
        return;
      }
    }
    onSubmit(_data);
    setErrors({});
  }
  const getSubditrict = async (code) => {
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.GETXA + "?huyen=" + code
      );
      setOptionSubDitrict(response?.data);
    } catch (error) {
      console.log(error);
      return;
    }
  };

  const handelClear = () => {
    onClose();
    setErrors([]);
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
      setGroup(data?.group);
      getSubditrict(data?.maquan);
    } else {
      setGroup([]);
      setDataState(defaultValue);
    }
  }, [data]);

  useEffect(() => {
    if (open) {
      setReValues(false);
      setValues(false);
      setErrors([]);
    }
  }, [open]);

  const handlePassVisibilty = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };
  const handleRePassVisibilty = () => {
    setReValues({
      ...revalues,
      showPass: !revalues.showPass,
    });
  };
  const handleChangeGroup = (e, newValue) => {
    setGroup(newValue);
  };
  const handleChangeDistrict = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        maquan: value,
        maphuong: "",
      };
    });
    getSubditrict(value);
  };
  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleOnFocus = (name) => (e) => {
    e.stopPropagation();
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleChangeAuth2 = (e) => {
    const { checked } = e.target;
    setDataState((prev) => ({
      ...prev,
      auth2: checked,
    }));
  };
  return (
    // <ThemeProvider theme={darkMode ? themeDark : themeLight}>
    <Dialog open={open} maxWidth={"md"}>
      <form ref={formRef} method="post" encType="multipart/form-data">
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {title ? title : "Tài khoản người dùng"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox sx={{ p: 1 }}>
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            <Grid container spacing={2} sx={{ textAlign: "left" }}>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Huyện <span style={{ color: "red" }}>*</span>
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    required
                    sx={{ padding: "0.7rem" }}
                    labelId="label-huyen"
                    name="maquan"
                    displayEmpty
                    onChange={handleChangeDistrict}
                    onFocus={handleOnFocus("maquan")}
                    MenuProps={MenuProps}
                    error={errors ? !!errors.maquan : false}
                    value={dataHuyen?.length > 0 ? dataState?.maquan || "" : ""}
                  >
                    <MenuItem value={""}>-- Chọn quận huyện --</MenuItem>
                    {dataHuyen &&
                      dataHuyen?.length > 0 &&
                      dataHuyen.map((item) => (
                        <MenuItem key={item.ma + "key_maquan"} value={item.ma}>
                          {item?.ten}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors && (
                    <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                      {errors.maquan}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Phường/Xã
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    required
                    sx={{ padding: "0.7rem" }}
                    labelId="label-phuong"
                    name="maphuong"
                    displayEmpty
                    MenuProps={MenuProps}
                    onFocus={handleOnFocus("maphuong")}
                    error={errors ? !!errors.maphuong : false}
                    onChange={handleChangeValueInput("maphuong")}
                    disabled={dataState.maquan ? false : true}
                    value={
                      optionSubDitrict?.length > 0
                        ? dataState?.maphuong || ""
                        : ""
                    }
                  >
                    <MenuItem value={""}>-- Chọn phường xã --</MenuItem>
                    {optionSubDitrict &&
                      optionSubDitrict?.length > 0 &&
                      optionSubDitrict.map((item) => (
                        <MenuItem
                          key={item.ma + "key_maphuong"}
                          value={item.ma}
                        >
                          {item?.ten}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors && (
                    <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                      {errors.maphuong}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Họ lót <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  required
                  name="first_name"
                  error={errors ? !!errors.first_name : false}
                  helperText={errors?.first_name}
                  value={dataState?.first_name || ""}
                  onChange={handleChangeValueInput("first_name")}
                  onFocus={handleOnFocus("first_name")}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Tên <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  required
                  name="last_name"
                  error={errors ? !!errors.last_name : false}
                  helperText={errors?.last_name}
                  value={dataState?.last_name || ""}
                  onChange={handleChangeValueInput("last_name")}
                  onFocus={handleOnFocus("last_name")}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Tài khoản <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  required
                  name="username"
                  error={errors ? !!errors.username : false}
                  helperText={errors?.username}
                  value={dataState?.username || ""}
                  onChange={handleChangeValueInput("username")}
                  onFocus={handleOnFocus("username")}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Email <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  required
                  fullWidth
                  name="email"
                  error={errors ? !!errors.email : false}
                  helperText={errors?.email}
                  value={dataState?.email || ""}
                  onChange={handleChangeValueInput("email")}
                  onFocus={handleOnFocus("email")}
                />
              </Grid>
              {visible && (
                <>
                  <Grid item xs={6}>
                    <Typography
                      fontSize={"0.75rem"}
                      color={"#000000"}
                      fontWeight={500}
                    >
                      Mật khẩu <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      required
                      type={values.showPass ? "text" : "password"}
                      name="password"
                      error={errors ? !!errors.password : false}
                      helperText={errors?.password}
                      value={dataState?.password || ""}
                      onChange={handleChangeValueInput("password")}
                      onFocus={handleOnFocus("password")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handlePassVisibilty}
                              aria-label="toggle password"
                              edge="end"
                            >
                              {values.showPass ? (
                                <VisibilityOffIcon />
                              ) : (
                                <VisibilityIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      fontSize={"0.75rem"}
                      color={"#000000"}
                      fontWeight={500}
                    >
                      Xác nhận lại Mật khẩu{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      required
                      type={revalues.showPass ? "text" : "password"}
                      name="repassword"
                      error={errors ? !!errors.repassword : false}
                      helperText={errors?.repassword}
                      value={dataState?.repassword || ""}
                      onChange={handleChangeValueInput("repassword")}
                      onFocus={handleOnFocus("repassword")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleRePassVisibilty}
                              aria-label="toggle password"
                              edge="end"
                            >
                              {revalues.showPass ? (
                                <VisibilityOffIcon />
                              ) : (
                                <VisibilityIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Ngày sinh
                </Typography>
                <TextField
                  type="date"
                  fullWidth
                  name="birth_date"
                  error={errors ? !!errors.birth_date : false}
                  helperText={errors?.birth_date}
                  value={dataState?.birth_date || ""}
                  onChange={handleChangeValueInput("birth_date")}
                  onFocus={handleOnFocus("birth_date")}
                />
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "left" }}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Giới tính <span style={{ color: "red" }}>*</span>
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    required
                    sx={{ padding: "0.7rem" }}
                    labelId="label-gioitinh"
                    value={dataState?.gender || "M"}
                    name="gender"
                    error={errors ? !!errors.gender : false}
                    onFocus={() => {
                      setErrors({
                        ...errors,
                        gender: "",
                      });
                    }}
                  >
                    <MenuItem value="M">Nam</MenuItem>
                    <MenuItem value="F">Nữ</MenuItem>
                    <MenuItem value="O">Khác</MenuItem>
                  </Select>
                  {errors && (
                    <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                      {errors.gender}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Địa chỉ
                </Typography>
                <TextField
                  fullWidth
                  name="address"
                  value={dataState?.address || ""}
                  onChange={handleChangeValueInput("address")}
                  onFocus={handleOnFocus("address")}
                />
              </Grid>
              <Grid item xs={6}>
                <RadioGroup
                  aria-labelledby="Trạng thái"
                  value={dataState?.is_active || false}
                  name="is_active"
                  row
                  onChange={handleChangeValueInput("is_active")}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Đã kích hoạt"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="Chưa kích hoạt"
                  />
                </RadioGroup>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "left" }}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={dataState?.auth2 || false}
                        onChange={handleChangeAuth2}
                      />
                    }
                    label="Xác thực 2 lớp"
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Nhóm người dùng <span style={{ color: "red" }}>*</span>
                </Typography>
                <Autocomplete
                  id="combo-box-group"
                  options={Object.values(dicGroup)}
                  sx={{
                    width: "100%",
                    ".MuiAutocomplete-tag": {
                      backgroundColor: "#1A73E8",
                      color: "#ffffff",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Chọn Nhóm người dùng"
                      error={errors ? !!errors.group : false}
                      helperText={errors.group}
                    />
                  )}
                  onChange={handleChangeGroup}
                  value={group}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderOption={(props, options) => (
                    <Box component="li" {...props} key={options.id}>
                      {options.name}
                    </Box>
                  )}
                  multiple
                  onFocus={() => {
                    setErrors({
                      ...errors,
                      group: "",
                    });
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={onSubmitForm}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Lưu
          </Button>
        </DialogActions>
      </form>
    </Dialog>
    // </ThemeProvider>
  );
};

const validateRequired = (value) => !!value.length;

function validateOBJ(user, visible, dungluong) {
  if (visible) {
    return {
      maquan: !validateRequired(user.maquan) ? "Chọn Huyện" : "",
      first_name: !validateRequired(user.first_name)
        ? "Họ lót không được trống"
        : "",
      last_name: !validateRequired(user.last_name)
        ? "Tên không được trống"
        : "",
      username: !validateRequired(user.username)
        ? "Tên tài khoản không được trống"
        : "",
      password: !validateRequired(user.password)
        ? "Mật khẩu không được trống"
        : "",
      repassword: !validateRequired(user.repassword)
        ? "Xác nhận mật khẩu không được trống"
        : "",
      email: !validateRequired(user.email) ? "Email không được trống" : "",
      picture: validateArrayFileRequired(user.picture, dungluong),
    };
  } else {
    return {
      maquan: !validateRequired(user.maquan) ? "Chọn Huyện" : "",
      first_name: !validateRequired(user.first_name)
        ? "Họ lót không được trống"
        : "",
      last_name: !validateRequired(user.last_name)
        ? "Tên không được trống"
        : "",
      username: !validateRequired(user.username)
        ? "Tên tài khoản không được trống"
        : "",
      email: !validateRequired(user.email) ? "Email không được trống" : "",
      picture: validateArrayFileRequired(user.picture, dungluong),
    };
  }
}

const validateEmail = (value) => {
  var pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );
  // var pattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.(vn|com)$/;
  let check = false;
  if (!pattern.test(value)) {
    check = true;
  }
  return check;
};

const checkconfirmpassword = (value, value1) => {
  let valid = false;
  if (value !== value1) {
    valid = true;
  }
  return valid;
};

export default CRUDUser;
